import script from "./XGrid.vue?vue&type=script&lang=tsx"
export * from "./XGrid.vue?vue&type=script&lang=tsx"

export default script